import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import {TicketTypeVo} from '../../common/shared/api/nicolas/vo/TicketTypeVo.enum';
import {TicketUseResultVo} from '../../common/shared/api/nicolas/vo/TicketUseResultVo.interface';

/**
 * 단건 이용권 사용 (대여/소장)
 *
 * Origin: pageNicolasApi.postTicketUse
 * API: POST /api/v1/ticket/use
 */
export async function postTicketUse(
  {
    productId,
    ticketType,
  }: {
    productId: number;
    ticketType?: TicketTypeVo;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: TicketUseResultVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/ticket/use',
    {
      method: 'POST',
      data: {
        product_id: productId,
        ...(ticketType && {ticket_type: ticketType}),
      },
    },
    options
  );
  return response.data;
}
